import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import VueStateManager from './infrastructure/state/vue-state-manager';
import {
  FinancialInstitutionHttpRepository,
  FinancialInstitutionDummyRepository,
} from './infrastructure/repository';

// Application
import { SearchFinancialInstitutionsQuery } from './application/queries';

// Domain
import { FinancialInstitutionRepository } from './domain/repository';
import { StateManager } from './domain/state/state-manager';

export default function setupFinancialInstitution(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<StateManager>(TYPES.CATALOG_ALLIANZ_FINANCIAL_INSTITUTION_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<FinancialInstitutionRepository>(TYPES.CATALOG_ALLIANZ_FINANCIAL_INSTITUTION_REPOSITORY)
    .to(
      withDummies
        ? FinancialInstitutionDummyRepository
        : FinancialInstitutionHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<SearchFinancialInstitutionsQuery>(
      TYPES.SEARCH_CATALOG_ALLIANZ_FINANCIAL_INSTITUTION_QUERY,
    )
    .to(SearchFinancialInstitutionsQuery)
    .inSingletonScope();
}
